import { Injectable } from '@angular/core';

import { Query, gql } from 'apollo-angular';

interface QueryHasActiveConsumableSubscriptionPayload {
  hasActiveConsumablesSubscriptions: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class HasActiveConsumableSubscriptionGqlService extends Query<QueryHasActiveConsumableSubscriptionPayload> {
  override document = gql`
    query HasActiveConsumablesSubscriptions {
      hasActiveConsumablesSubscriptions
    }
  `;
}
